// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1af0S","head":"ProcedureTableInfo_head__NkQZt"};